import { render, staticRenderFns } from "./ManagerStatistics.vue?vue&type=template&id=3168b412&scoped=true&lang=pug&"
import script from "./ManagerStatistics.vue?vue&type=script&lang=js&"
export * from "./ManagerStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ManagerStatistics.vue?vue&type=style&index=0&id=3168b412&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3168b412",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
